import React, { Children, useState } from "react";

import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";

// import JS files
// import { useUserData } from "../../context/UserDataContext";
import MuiTheme from "./MuiTheme";

// import Others files

const Input = styled("input")({
  display: "none",
});
const UploadButton = styled(Button)({
  color: "#6e6e6e",
  border: "1px solid #bdbdbd",
  "&:hover": {
    backgroundColor: "transparent",
    color: "#1976d2",
  },
  "&:active": {},
  "&:focus": {},
});

const MuiUpload = ({ setFile, label, id, accept }) => {
  const handlePictureFile = (e) => {
    const file = e.target.files[0];
    if (
      (file.type.includes("image/") && file.size <= 1000000) ||
      (file.type.includes("video/") && file.size <= 5000000)
    ) {
      setFile(file);
    } else if (file.size <= 5000000) {
      setFile(file);
    } else {
      toast.error("حجم فایل انتخابی شما بیشتر از مقدار مجاز است", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    e.target.value = null;
  };

  return (
    <>
      <MuiTheme>
        <label htmlFor={id}>
          <Input
            accept={accept}
            id={id}
            type="file"
            onChange={(e) => handlePictureFile(e)}
          />
          <UploadButton
            variant="text"
            component="span"
            style={{ display: "flex" }}
          >
            <span>{label}</span>
          </UploadButton>
        </label>
      </MuiTheme>
    </>
  );
};

export default MuiUpload;
